/** Base / trading location from stored plumber fields - not the directory browse path. */
export function formatPlumberBaseLocation(plumber: {
  city?: string
  region?: string
  postcode?: string
  postcodeArea?: string
}): string {
  const city = plumber.city?.trim()
  const region = plumber.region?.trim()
  const line = [city, region].filter(Boolean).join(', ')
  if (line) return line
  const pc = plumber.postcode?.trim()
  if (pc) return pc.toUpperCase()
  return plumber.postcodeArea?.trim() || ''
}
